"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectCombinedPlayerStatus = exports.selectIsFinalTask = exports.selectThisPlayerContent = exports.selectThisPlayerCurrentInformation = exports.selectThisPlayerCurrentInfo = exports.selectPlayerInfoFromPlayerId = exports.selectPlayerInfoIdFromPlayerId = exports.selectCurrentEvent = exports.selectCurrentTask = exports.selectCurrentTaskNumber = exports.selectNumberOfTasks = exports.selectConnectedStates = exports.selectNumberOfConnectedPlayers = exports.selectIsInvited = exports.selectIsPlayerInRoom = exports.selectPlayerIndex = exports.selectIsSpaceInRoom = exports.selectNextFreePlayerSlot = exports.selectThisPlayerCharacterName = exports.selectThisPlayerState = exports.selectPlayerStateFromPlayerId = exports.selectThisPlayerName = exports.selectRoomId = exports.selectRoomName = exports.selectElapsed = exports.selectRoomSize = exports.selectPlayerNames = exports.selectThisPlayerId = undefined;

var _reselect = require("reselect");

var _PlayerStatuses = require("../constants/PlayerStatuses");

var playerStatuses = _interopRequireWildcard(_PlayerStatuses);

var _Misc = require("../constants/Misc");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var selectGame = function selectGame(state) {
  return state.game;
};

var selectUsername = function selectUsername(state) {
  return state.meta.username;
};

var selectThisPlayerId = exports.selectThisPlayerId = (0, _reselect.createSelector)(selectGame, selectUsername, function (game, username) {
  return game.playerNames.findIndex(function (name) {
    return name === username;
  });
});
var selectPlayerNames = exports.selectPlayerNames = (0, _reselect.createSelector)(selectGame, function (game) {
  return game.playerNames;
});
var selectRoomSize = exports.selectRoomSize = (0, _reselect.createSelector)(selectGame, function (game) {
  return game.roomSize;
});
var selectElapsed = exports.selectElapsed = (0, _reselect.createSelector)(selectGame, function (game) {
  return game.elapsed;
});
var selectRoomName = exports.selectRoomName = (0, _reselect.createSelector)(selectGame, function (game) {
  return game.roomName;
});
var selectRoomId = exports.selectRoomId = (0, _reselect.createSelector)(selectGame, function (game) {
  return game.roomId;
});
var selectGameEntities = (0, _reselect.createSelector)(selectGame, function (game) {
  return game.entities;
});
var selectEventsMap = (0, _reselect.createSelector)(selectGameEntities, function (entities) {
  return entities.eventsMap;
});
var selectPlayerInfoById = (0, _reselect.createSelector)(selectGameEntities, function (entities) {
  return entities.playerInfoById;
});
var selectThisPlayerName = exports.selectThisPlayerName = (0, _reselect.createSelector)(selectPlayerNames, selectThisPlayerId, function (playerNames, id) {
  return playerNames[id];
});
var selectPlayerStatesById = (0, _reselect.createSelector)(selectGameEntities, function (entities) {
  return entities.playerStatesById;
});

var selectPlayerStateFromPlayerId = exports.selectPlayerStateFromPlayerId = function selectPlayerStateFromPlayerId(state, playerId) {
  return selectPlayerStatesById(state)[playerId];
};

var selectThisPlayerState = exports.selectThisPlayerState = (0, _reselect.createSelector)(selectPlayerStatesById, selectThisPlayerId, function (playerStates, id) {
  return playerStates[id];
});
var selectThisPlayerCharacterName = exports.selectThisPlayerCharacterName = (0, _reselect.createSelector)(selectThisPlayerState, function (playerState) {
  return playerState.characterName;
});
var selectNextFreePlayerSlot = exports.selectNextFreePlayerSlot = (0, _reselect.createSelector)(selectPlayerNames, selectRoomSize, function (playerNames, roomSize) {
  return playerNames.length >= roomSize ? playerNames.indexOf(_Misc.EMPTY_PLAYER_SLOT) : playerNames.length;
});
var selectIsSpaceInRoom = exports.selectIsSpaceInRoom = (0, _reselect.createSelector)(selectNextFreePlayerSlot, function (freeSlotIndex) {
  return freeSlotIndex !== -1;
});

var selectPlayerIndex = exports.selectPlayerIndex = function selectPlayerIndex(state, playerName) {
  return selectPlayerNames(state).indexOf(playerName);
};

var selectIsPlayerInRoom = exports.selectIsPlayerInRoom = (0, _reselect.createSelector)(selectPlayerIndex, function (index) {
  return index !== -1;
});
var selectInvites = (0, _reselect.createSelector)(selectGame, function (game) {
  return game.invites;
});
var selectIsInvited = exports.selectIsInvited = (0, _reselect.createSelector)(selectInvites, function (playerName) {
  return playerName;
}, function (invites, name) {
  return invites.includes(name);
});
var selectNumberOfConnectedPlayers = exports.selectNumberOfConnectedPlayers = (0, _reselect.createSelector)(selectPlayerStatesById, function (playerStates) {
  return playerStates ? Object.values(playerStates).filter(function (state) {
    return !!state.isConnected;
  }).length : 0;
});
var selectConnectedStates = exports.selectConnectedStates = (0, _reselect.createSelector)(selectPlayerStatesById, function (playerStates) {
  return playerStates && Object.values(playerStates).map(function (state) {
    return state.isConnected;
  });
}); //Current task information

var selectTasks = (0, _reselect.createSelector)(selectGameEntities, function (entities) {
  return entities.tasks;
});
var selectNumberOfTasks = exports.selectNumberOfTasks = (0, _reselect.createSelector)(selectTasks, function (tasks) {
  return Object.keys(tasks).length;
});
var selectCurrentTaskNumber = exports.selectCurrentTaskNumber = (0, _reselect.createSelector)(selectGame, function (game) {
  return game.currentTaskNumber;
});
var selectCurrentTask = exports.selectCurrentTask = (0, _reselect.createSelector)(selectTasks, selectCurrentTaskNumber, function (tasks, i) {
  return tasks && tasks[i];
});
var selectCurrentEvent = exports.selectCurrentEvent = (0, _reselect.createSelector)(selectEventsMap, selectCurrentTaskNumber, function (map, i) {
  return map[i];
});
var selectCurrentPlayerInfo = (0, _reselect.createSelector)(selectCurrentTask, function (task) {
  return task && task.playerInfo;
});

var selectPlayerInfoIdFromPlayerId = exports.selectPlayerInfoIdFromPlayerId = function selectPlayerInfoIdFromPlayerId(state, playerId) {
  return selectCurrentPlayerInfo(state)[playerId];
};

var selectPlayerInfoFromPlayerId = exports.selectPlayerInfoFromPlayerId = function selectPlayerInfoFromPlayerId(state, playerId) {
  return selectPlayerInfoById(state)[selectPlayerInfoIdFromPlayerId(state, playerId)];
};

var selectThisPlayerCurrentInfoId = (0, _reselect.createSelector)(selectCurrentPlayerInfo, selectThisPlayerId, function (info, id) {
  return info[id];
});
var selectThisPlayerCurrentInfo = exports.selectThisPlayerCurrentInfo = (0, _reselect.createSelector)(selectPlayerInfoById, selectThisPlayerCurrentInfoId, function (infos, id) {
  return infos[id];
});
var selectThisPlayerCurrentInformation = exports.selectThisPlayerCurrentInformation = (0, _reselect.createSelector)(selectThisPlayerCurrentInfo, function (info) {
  return info.information;
});
var selectThisPlayerCurrentLanguages = (0, _reselect.createSelector)(selectThisPlayerCurrentInfo, function (info) {
  return info.languages;
});
var selectThisPlayerCode = (0, _reselect.createSelector)(selectThisPlayerState, function (state) {
  return state.code;
});
var selectThisPlayerContent = exports.selectThisPlayerContent = (0, _reselect.createSelector)(selectThisPlayerCode, selectThisPlayerCurrentLanguages, function (code, langs) {
  return langs.map(function (lng, i) {
    return {
      name: lng,
      type: lng,
      content: code[i]
    };
  });
});
var selectIsFinalTask = exports.selectIsFinalTask = (0, _reselect.createSelector)(selectNumberOfTasks, selectCurrentTaskNumber, function (total, current) {
  return current >= total - 1;
});
var selectPlayer0State = (0, _reselect.createSelector)(selectPlayerStatesById, function (states) {
  return states[0];
});
var selectPlayer1State = (0, _reselect.createSelector)(selectPlayerStatesById, function (states) {
  return states[1];
});
var selectCombinedPlayerStatus = exports.selectCombinedPlayerStatus = (0, _reselect.createSelector)(selectPlayer0State, selectPlayer1State, function (state0, state1) {
  var DEFAULT = playerStatuses.DEFAULT,
      DONE = playerStatuses.DONE,
      READY_FOR_NEXT = playerStatuses.READY_FOR_NEXT;

  if (!state0 || !state1) {
    return DEFAULT;
  }

  var p0 = state0.status;
  var p1 = state1.status;

  switch (true) {
    case !p0 && !p1:
      return DEFAULT;

    case !p0:
      return p1;

    case !p1:
      return p0;

    case p0 === DONE && p1 === DONE:
      return DONE;
    //TODO: A bit of a hack for interim state (when one player has pressed next and the other hasn't yet)

    case p0 === DONE && p1 === READY_FOR_NEXT:
    case p0 === READY_FOR_NEXT && p1 === DONE:
      return DONE;

    case p0 === READY_FOR_NEXT && p1 === READY_FOR_NEXT:
      return READY_FOR_NEXT;

    default:
      return DEFAULT;
  }
});